import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import {withContext} from '../../../custom/StateProvider';
import {connect} from "react-redux";
import {API} from "../../../../config";
import Utils from "../../../custom/utils";

const holdings = API.service('holdings');

const styles = theme => ({
  root                    : {},

  avatar                  : {},

  reportTable             : {
    width                 :'100%',
    paddingTop            : '30px'
  },

  reportHeading           : {
    fontWeight            :'bold'
  }
});

class InvestorHoldings extends Component {
  state = {
    holdings: false
  }

  componentDidMount() {
    const app = this;
    holdings.find({query:{incl:['company','investors'],$limit:10000,_type:{$ne:'DEAD'}}}).then(h=>{
      console.log(h)
      app.setState({
        holdings:h.data
      })
    })
  }

  investorState(state) {
    let InvStatus = Utils.returnState(state);
    return(
      <div className={'kyc-label ' + InvStatus[0]}>{InvStatus[1]}</div>
    )
  }

  render() {
    const { classes} = this.props;
    let count = 0;
    return (
      <React.Fragment>
      <table className={classes.reportTable}>
        <tr className={classes.reportHeading}>
          <td>Account</td>
          <td>Investor</td>
          <td>Agent</td>
          <td style={{textAlign:'center'}}>Investor Status</td>
          <td>Instrument</td>
          <td>Holding Type</td>
          <td style={{textAlign:'right'}}>Holding Amount</td>
        </tr>
        { (this.state.holdings) &&
          (this.state.holdings.map((v,k)=>{
            if((!Utils.isEmpty(this.props.user.affiliate)&& v.investor._affiliate === this.props.user.affiliate) || Utils.isEmpty(this.props.user.affiliate)){
              count++;
              return(
                <tr key={k}>
                  <td>{(typeof v.investor !== 'undefined' && v.investor !== null) ? v.investor._account :'No Investor'}</td>
                  <td>{(typeof v.investor !== 'undefined' && v.investor !== null) ? v.investor._firstname : ''} {(typeof v.investor !== 'undefined' && v.investor !== null) ? v.investor._surname : ''}</td>
                  <td>{(typeof v.investor !== 'undefined' && v.investor !== null) ? v.investor._affiliate : ''} </td>
                  <td style={{textAlign:'center'}}>{(typeof v.investor !== 'undefined' && v.investor !== null) ? this.investorState(v.investor._states) : ''}</td>
                  {(v.company !== null) &&
                    <td>{v.company._company_name} ({v.company._trading_symbol})</td>
                  }
                  {(v.company === null) &&
                    <td>{v._company_account}</td>
                  }
                  <td>{v._type}</td>
                  <td style={{textAlign:'right'}}>{Utils.addThousandCommas(v._quantity)}</td>
                </tr>
              )
              } else {
                return false
              }
            }))
        }
      </table>
      {(count === 0) &&
        <div style={{marginTop:15,textAlign:'center'}}>No Results</div>
      }
      </React.Fragment>
    )
  }
}

function mapStateToProps({ fuse, auth }) {
  return {
    user: auth.user
  }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(InvestorHoldings))));
